















































































































































































































































import Vue from "vue";
import configProvider from "../../services/configProvider";
import router from "@/router";
import userInfoProvider from "../../services/userInfoProvider";

export default Vue.extend({
  data() {
    return {
      host: configProvider.get("DOWNLOAD_HOST", ""),
      guideVideoUrlIos: configProvider.get("GUIDE_VIDEO_URL_IOS"),
      guideVideoUrlAndroid: configProvider.get("GUIDE_VIDEO_URL_ANDROID"),
      guideVideoUrlPC: configProvider.get("GUIDE_VIDEO_URL_PC"),
      userInfo: userInfoProvider.getUserInfo(),
      downloadToken: "5JckyXbswsTToNrYV4CRc1C4j9dqZCq8"
    };
  },
  created() {},
  methods: {
    goToLogin(ctx = "") {
      const token = userInfoProvider.getAccessToken();
      if (token) {
        router.push("/mfa-management");
      } else {
        router.push(`/login?ctx=${ctx}`);
      }
    },
    getBranch(platform) {
      const branch = configProvider.get(
        `DOWNLOAD_DEFAULT_BRANCH_${platform.toUpperCase()}`,
        ""
      );
      if (branch) {
        return branch;
      }
      return configProvider.get("DOWNLOAD_DEFAULT_BRANCH", "production");
    },
    downloadIos() {
      const url = `https://apps.apple.com/us/app/m-suite/id6444675982`;
      location.href = url;
    }
  }
});
